var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4118 1.46298e-06C9.04558 0.010875 8.75076 0.237782 8.6213 0.487054L7.38972 2.94123H2.64698C1.19565 2.94123 0 4.13714 0 5.5882V17.353C0 18.8043 1.19591 20 2.64698 20H23.2354C24.6867 20 25.8824 18.8041 25.8824 17.353V5.5882C25.8824 4.13688 24.6865 2.94123 23.2354 2.94123H18.4927L17.2611 0.487054C17.115 0.195723 16.7966 -0.000618291 16.4706 1.46298e-06H9.4118ZM9.96327 1.76483H15.9192L17.1508 4.219C17.2969 4.51033 17.6153 4.70667 17.9413 4.70605H23.2355C23.7395 4.70605 24.1179 5.08437 24.1179 5.58847V17.3533C24.1179 17.8574 23.7396 18.2357 23.2355 18.2357H2.64703C2.14295 18.2357 1.76462 17.8574 1.76462 17.3533V5.58847C1.76462 5.08438 2.14293 4.70605 2.64703 4.70605H7.9412C8.2672 4.70605 8.58564 4.51033 8.7317 4.219L9.96327 1.76483ZM12.9412 5.58845C9.86543 5.58845 7.3529 8.10086 7.3529 11.1767C7.3529 14.2527 9.86532 16.765 12.9412 16.765C16.0171 16.765 18.5295 14.2526 18.5295 11.1767C18.5295 8.10097 16.0171 5.58845 12.9412 5.58845ZM12.9412 7.35327C15.0634 7.35327 16.7648 9.05471 16.7648 11.1769C16.7648 13.2991 15.0634 15.0005 12.9412 15.0005C10.8192 15.0005 9.11757 13.2991 9.11757 11.1769C9.11757 9.05471 10.819 7.35327 12.9412 7.35327Z",
    fill: "#167092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.ba7dbf7d199299a237638cb5a47b8d05.svg";
export { ForwardRef as ReactComponent };